export const TABLE_APPROVE_TAG_COLOR = '#24c2a1'
export const TABLE_UNAPPROVE_TAG_COLOR = '#f8bb6a'
export const DEFAULT_ICON_COLOR = '#575757'
